import type {Color} from "../../../generated/api/base";
import {BasicColors} from "../../../utils/BasicColors";
import {ColorPaletteV5} from "./ColorPaletteV5";

interface IBasicColorPanelProps {
	readonly color: Color;
	readonly onColorChange: (newColor: Color) => void;
	readonly isMiniColorPalette?: boolean;
}

export const BasicColorPanelV5 = (props: IBasicColorPanelProps) => {
	const {color, isMiniColorPalette} = props;

	const colorPalette: Color[] = isMiniColorPalette ? BasicColors.getNavigationPanelColorsV5() : BasicColors.getBasicColorsV5();

	return (
		<ColorPaletteV5
			activeColor={color}
			colors={colorPalette}
			onColorClick={props.onColorChange}
			isMiniColorPalette={isMiniColorPalette}
		/>
	);
};
